// @flow
import algoliaSearch from 'utils/algoliaSearch';
import getSearchConfig from 'utils/search/getSearchConfig';
import { getJson, postJson, del } from 'utils/http';
import type { ImageData } from 'api/shared';
import { requiredConfig } from 'utils/config';

type PublicUserData = {
  id: string,
  firstName: ?string,
  lastName: ?string,
  description: ?string,
  descriptionTruncated: ?string,
  links: Array<string>,
  image: ?ImageData
};

export type Pin = {
  date: ?string,
  id: string,
  created: string,
  updated: string,
  userId: string,
  latitude: number,
  longitude: number,
  withProfile: boolean,
  text: string,
  profile?: PublicUserData
};

export type PinInfo = {
  latitude: number,
  longitude: number,
  withProfile: boolean,
  text: string
};

// Redux
export type DaysMap = {
  mapState: ?boolean
};

export type Pins = Array<Pin>;

export function setPin(date: string, pinInfo: PinInfo): Promise<Pin> {
  return postJson(`/data/website/idealist-days-map/${date}`, pinInfo).then(
    ({ pin }) => pin
  );
}

export function deletePin(pinId: string): Promise<void> {
  return del(`/data/website/idealist-days-map-pins/${pinId}`);
}

export function fetchPin(pinId: string): Promise<Pin> {
  return getJson(`/data/website/idealist-days-map-pins/${pinId}`).then(
    ({ pin }) => pin
  );
}

export function fetchPins(date: string): Promise<Array<Pin>> {
  return getJson(`/data/website/idealist-days-map/${date}`).then(
    ({ pins }) => pins
  );
}

export function fetchIdealistDaysEvents(date: string): Promise<Array<Object>> {
  const searchConfig = getSearchConfig();
  return algoliaSearch(searchConfig, '', {
    index: requiredConfig('algolia', 'siteIndexName'),
    attributesToRetrieve: '*', // TODO fetch only what's needed
    hitsPerPage: 1000,
    facetFilters: [[`idealistDay:${date}`], ['type:IDEALIST_DAY_EVENT']]
  }).then(({ hits }) => hits);
}

export function fetchGroups(): Promise<Array<Object>> {
  const searchConfig = getSearchConfig();
  return algoliaSearch(searchConfig, '', {
    index: requiredConfig('algolia', 'siteIndexName'),
    attributesToRetrieve: '*', // TODO fetch only what's needed
    hitsPerPage: 1000,
    facetFilters: [['type:GROUP']]
  }).then(({ hits }) => hits);
}
